@if (processedSubscriptions.length > 0) {
<div class="container">
  @for (subscription of processedSubscriptions; track subscription) {
  <div class="header-wrapper-container">
    <div class="tab">
      <div ><mat-icon>key</mat-icon></div>
      <div class="key">{{'key' | translate}}</div>
    </div> 
    <div class="header-wrapper" >

      <div class="subscription-type">
        <p>{{'type' | translate}}</p>
        <p class="type-description" [matTooltip]="subscription.planDescription">
          {{subscription.planDescription}}
        </p>        
      </div>

      <div class="status-duration">

        <div class="status-days">
          <div>
            <p>{{'status' | translate}}</p>
            <p class="label"
              [ngClass]="{
               'active-label': subscription.subscriptionStatus === 'Active',
               'expiring-soon-label': subscription.subscriptionStatus === 'Expiring Soon',
               'expired-label': subscription.subscriptionStatus === 'Expired',
               'future-label': subscription.subscriptionStatus === 'Starts'
              }">
              @if (subscription.subscriptionStatus === 'Starts') {
                {{subscription.subscriptionStatus}} {{ subscription.subscriptionStartDate | date: 'dd-MM-yyyy':'UTC'}}
              } @else {
                {{subscription.subscriptionStatus}}
              }
            </p>
          </div>
          <div>
            <p>{{'days_left' | translate}}</p>
            <p class="days"
              [ngClass]="{
               'active-days': subscription.subscriptionStatus === 'Active',
               'expiring-soon-days': subscription.subscriptionStatus === 'Expiring Soon',
               'expired-days': subscription.subscriptionStatus === 'Expired',
               'future-days': subscription.subscriptionStatus === 'Starts'
              }">{{subscription.daysLeft}}
            </p>
          </div>
        </div>

        <div class="duration-dates">
          <div>
            <p>{{'duration' | translate}}</p>
            <p class="duration">{{subscription.duration}}</p>
          </div>
          <div class="dates">
            <div>
              <p>{{'start' | translate}}</p>
              <p><strong>{{ subscription.subscriptionStartDate | date: 'dd-MM-yyyy':'UTC' }}</strong></p>
            </div>
            <div>
              <p>{{'end' | translate}}</p>
              <p><strong>{{ subscription.subscriptionEndDate | date: 'dd-MM-yyyy':'UTC' }}</strong></p>
            </div>
          </div>
        </div>

      </div>

      <div class="purchased-by">
        <div>
          <p>{{'purchased_by' | translate}}</p>
          <div class="subscription-level">
            <div class="mail-icon">&#9993;</div>
            <div class="email" [matTooltip]="subscription.endUserEmail">
              {{subscription.endUserEmail}}
            </div>
          </div>
        </div> 
      </div>
    </div>
  </div>
  }
</div>
}

<div class="container" >
  @if (processedSubscriptions.length == 0) {
  <div class="header-wrapper-2">
    <p>{{'no_subscriptions_message' | translate}}</p>
  </div>
  }
</div>

@if (isLoading) {
<app-spinner>
</app-spinner>
}
    